// src/components/GodsView.jsx

import "leaflet/dist/leaflet.css";
import './godsView.css';
import 'leaflet.gridlayer.googlemutant';
import 'leaflet-routing-machine';
import 'react-toastify/dist/ReactToastify.css';

import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { ToastContainer, toast } from 'react-toastify';
import {
  convertToFormat,
  getCompanyFormat,
  getCompanyId,
  getGroupFilterQuery,
  getMapIcon,
  showContent
} from "../utilis/helper";
import { getEquipmentFilterDetails, getGroupSearchDetails, getParentGroupDetails } from "../utilis/searchHelper";

import { AsyncPaginate } from 'react-select-async-paginate';
import Button from '@mui/material/Button';
import L from "leaflet";
import Select from 'react-select';
import StreetViewModalCard from "./StreetViewModalCard";
import TextField from '@mui/material/TextField';
import api from "../utilis/api";
import debounce from "lodash.debounce";
import loadingspinner from "../images/loading.gif";
import socketIOClient from "socket.io-client";
import { useIntl } from 'react-intl';

const { parse, stringify } = require("wkt");

const calculateDistanceKm = (from, to) => {
  if (!from || !to) return null;
  const fromLat = Number(from.lat);
  const fromLng = Number(from.lng);
  const toLat = Number(to.lat);
  const toLng = Number(to.lng);
  if (
    !Number.isFinite(fromLat) ||
    !Number.isFinite(fromLng) ||
    !Number.isFinite(toLat) ||
    !Number.isFinite(toLng)
  ) {
    return null;
  }
  const meters = L.latLng(fromLat, fromLng).distanceTo([toLat, toLng]);
  return Number.isFinite(meters) ? meters / 1000 : null;
};

//const webSocket = "wss://redis.intellitech.cl";
const webSocket = process.env.REACT_APP_WEBSOCKET;
//const webSocket = "ws://127.0.0.1:3001";


const all = { value: -1, label: "Todos" };
let polyLineLayer = [];

const AVERAGE_TRAVEL_SPEED_KMH = 40;

const tileProxyBaseUrl = (process.env.REACT_APP_TILE_PROXY_URL || process.env.REACT_APP_BASE_URL || "")
  .replace(/\/api\/?$/, "")
  .replace(/\/$/, "");
const tileProxyUrl = tileProxyBaseUrl ? `${tileProxyBaseUrl}/tiles` : "/tiles";
const baseTileOptions = {
  maxZoom: 20,
  updateWhenIdle: true,
  updateWhenZooming: false,
  keepBuffer: 3,
  reuseTiles: true,
  detectRetina: false,
};

const tileLayers = (intl) => {
  return {
    [intl.formatMessage({ id: "routingmap.googleTerrain" })]: L.tileLayer(
      `${tileProxyUrl}/google-terrain/{z}/{x}/{y}.jpg`,
      { ...baseTileOptions, maxNativeZoom: 20 }
    ),
    [intl.formatMessage({ id: "routingmap.hybridMap" })]: L.tileLayer(
      `${tileProxyUrl}/google-hybrid/{z}/{x}/{y}.jpg`,
      { ...baseTileOptions, maxNativeZoom: 20 }
    ),
    [intl.formatMessage({ id: "routingmap.satelliteMap" })]: L.tileLayer(
      `${tileProxyUrl}/google-satellite/{z}/{x}/{y}.jpg`,
      { ...baseTileOptions, maxNativeZoom: 20 }
    ),
  };
};

let mapInstance = null;
let focusedMarkers = new Set();

export default function GodsView() {
  const [authUser, setAuthUser] = useState(null);
  const [equipments, setEquipments] = useState([]);
  const [equipmentsOptions, setEquipmentsOptions] = useState([]);
  const [equipmentId, setEquipmentId] = useState(null);

  const [parentGroup, setParentGroup] = useState(null);
  const [group, setGroup] = useState(null);
  const [equipment, setEquipment] = useState(null);

  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);

  const [IsStreetViewModal, setStreetViewModal] = useState(false);
  const [streetLocation, setStreetLocation] = useState([]);

  const [searchBy, setSearchBy] = useState(Math.random());
  const [searchBy1, setSearchBy1] = useState(Math.random());
  const [geoZones, setGeoZones] = useState(null);
  const [routeCode, setRouteCode] = useState('');
  const [pageVisible, setPageVisible] = useState(!document.hidden);
  const [userLocation, setUserLocation] = useState(null);
  const [geoError, setGeoError] = useState(null);

  const routePopupOptions = useMemo(
    () => ({ hideFields: ['driver', 'speed', 'orientation', 'coordinates'] }),
    []
  );

  const mapRef = useRef(null);
  const markerLayerRef = useRef(null);
  const equipmentMarkersRef = useRef({});
  const latestPositionsRef = useRef({});
  const latestTrackpointsRef = useRef({});
  const socketRef = useRef(null);
  const firstFitRef = useRef(true);
  const layerControlRef = useRef(null);
  const userLocationRef = useRef(null);
  const userMarkerRef = useRef(null);
  const userAccuracyCircleRef = useRef(null);
  const geoWatchIdRef = useRef(null);
  const userRouteControlRef = useRef(null);
  const selectedVehicleRef = useRef(null);
  const intl = useIntl();

  // Track page visibility to control animations
  useEffect(() => {
    const handleVisibility = () => setPageVisible(!document.hidden);
    document.addEventListener('visibilitychange', handleVisibility);
    return () => document.removeEventListener('visibilitychange', handleVisibility);
  }, []);

  const maplayerKeyMap = {
    hybridMap: intl.formatMessage({ id: "routingmap.hybridMap" }),
    satelliteMap: intl.formatMessage({ id: "routingmap.satelliteMap" }),
    googleTerrain: intl.formatMessage({ id: "routingmap.googleTerrain" }),
    trafficMap: intl.formatMessage({ id: "routingmap.trafficMap" }),
    hybirdtrafficMap: intl.formatMessage({ id: "routingmap.hybirdtrafficMap" }),
  };

  useEffect(() => {
    if (!mapInstance) {
      initMap();
    }
    //cleanup on unmount
    return () => {
      if (mapInstance) {
        mapInstance.remove();
        mapInstance = null;
        equipmentMarkersRef.current = {};
      }
      if (userRouteControlRef.current) {
        userRouteControlRef.current.remove();
        userRouteControlRef.current = null;
      }
      selectedVehicleRef.current = null;
    };
  }, []);

  useEffect(() => {
    if (!window.google && !document.querySelector('#google-maps-script')) {
      const script = document.createElement('script');
      script.id = 'google-maps-script';
      script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_KEY}&loading=async`;
      script.async = true;
      script.defer = true;
      script.onload = () => { };
      document.body.appendChild(script);
    } else {
      // Google Maps API already loaded
    }
  }, []);

  useEffect(() => {
    if (layerControlRef.current == null) {
      var layers = tileLayers(intl);

      if (authUser?.company?.trafficLayer) {
        layers[maplayerKeyMap.trafficMap] = L.gridLayer
          .googleMutant({ type: "roadmap", model: "traffic" })
          .addGoogleLayer("TrafficLayer");
        layers[maplayerKeyMap.hybirdtrafficMap] = L.gridLayer
          .googleMutant({ type: "hybrid", model: "traffic" })
          .addGoogleLayer("TrafficLayer");
      }

      // Always default to the hybrid map for the routes page
      const selectedLayerKey = "hybridMap";
      const selectedLayer = layers[maplayerKeyMap[selectedLayerKey]];
      if (selectedLayer) {
        selectedLayer.addTo(mapInstance);
      }

      // Do not show the map layer selection control on the routes page
      if (layerControlRef.current) {
        layerControlRef.current = null;
      }


      markerLayerRef.current = L.layerGroup().addTo(mapInstance);
    }
  }, [authUser]);

  useEffect(() => {
    if (geoZones) {
      drawGeoZones();
    }
  }, [geoZones]);

  const drawNavigationLine = useCallback(
    (targetLatLng) => {
      const map = mapRef.current;
      const userLoc = userLocationRef.current;
      if (!map) return;

      const hasUser =
        userLoc &&
        Number.isFinite(Number(userLoc.lat)) &&
        Number.isFinite(Number(userLoc.lng));

      const clearRoute = () => {
        if (userRouteControlRef.current) {
          userRouteControlRef.current.remove();
          userRouteControlRef.current = null;
        }
      };

      if (!hasUser) {
        clearRoute();
        return;
      }

      if (targetLatLng === null) {
        clearRoute();
        return;
      }

      let target = targetLatLng;
      if (!target && selectedVehicleRef.current) {
        const marker = equipmentMarkersRef.current[selectedVehicleRef.current];
        if (marker) {
          target = marker.getLatLng();
        }
      }

      if (!target) {
        return;
      }

      const toLat =
        typeof target.lat === 'number'
          ? target.lat
          : Array.isArray(target)
          ? target[0]
          : undefined;
      const toLng =
        typeof target.lng === 'number'
          ? target.lng
          : Array.isArray(target)
          ? target[1]
          : undefined;

      if (!Number.isFinite(Number(toLat)) || !Number.isFinite(Number(toLng))) {
        return;
      }

      const createRouteControl = () => {
        if (!L.Routing || !L.Routing.control || !L.Routing.osrmv1) {
          return null;
        }

        const control = L.Routing.control({
          waypoints: [],
          lineOptions: {
            styles: [{ color: '#1976d2', weight: 4, opacity: 0.8, dashArray: '6,6' }],
          },
          router: L.Routing.osrmv1({
            serviceUrl: 'https://router.project-osrm.org/route/v1',
          }),
          addWaypoints: false,
          draggableWaypoints: false,
          routeWhileDragging: false,
          fitSelectedRoutes: false,
          show: false,
          createMarker: () => null,
        }).addTo(map);

        if (typeof control.hide === 'function') {
          control.hide();
        } else if (control._container) {
          control._container.style.display = 'none';
        }

        return control;
      };

      const ensureControl = () => {
        if (userRouteControlRef.current && typeof userRouteControlRef.current.setWaypoints === 'function') {
          return userRouteControlRef.current;
        }

        if (userRouteControlRef.current) {
          userRouteControlRef.current.remove();
          userRouteControlRef.current = null;
        }

        const control = createRouteControl();
        if (control) {
          userRouteControlRef.current = control;
          return control;
        }

        const fallback = L.polyline([], {
          color: '#1976d2',
          weight: 4,
          opacity: 0.8,
          dashArray: '6,6',
        }).addTo(map);
        userRouteControlRef.current = fallback;
        return fallback;
      };

      const waypoints = [
        L.latLng(Number(userLoc.lat), Number(userLoc.lng)),
        L.latLng(Number(toLat), Number(toLng)),
      ];

      const control = ensureControl();
      if (control.setWaypoints) {
        control.setWaypoints(waypoints);
        if (typeof control.hide === 'function') {
          control.hide();
        } else if (control._container) {
          control._container.style.display = 'none';
        }
      } else if (control.setLatLngs) {
        control.setLatLngs(waypoints.map((wp) => [wp.lat, wp.lng]));
      } else {
        control.remove();
        userRouteControlRef.current = null;
      }
    },
    [equipmentMarkersRef, mapRef, selectedVehicleRef, userLocationRef, userRouteControlRef]
  );

  const updateUserMarker = useCallback((location) => {
    const map = mapRef.current;
    if (!map) return;

    const latNum = Number(location?.lat);
    const lngNum = Number(location?.lng);
    if (!Number.isFinite(latNum) || !Number.isFinite(lngNum)) return;
    const latLng = [latNum, lngNum];

    if (userMarkerRef.current) {
      userMarkerRef.current.setLatLng(latLng);
    } else {
      const marker = L.circleMarker(latLng, {
        radius: 7,
        color: '#1976d2',
        fillColor: '#1976d2',
        fillOpacity: 0.85,
        weight: 2,
      });
      marker.bindPopup(intl.formatMessage({ id: 'gps.youAreHere', defaultMessage: 'Your location' }));
      marker.addTo(map);
      userMarkerRef.current = marker;
    }

    const accuracy = Number(location?.accuracy);
    if (Number.isFinite(accuracy) && accuracy > 0) {
      if (userAccuracyCircleRef.current) {
        userAccuracyCircleRef.current.setLatLng(latLng);
        userAccuracyCircleRef.current.setRadius(accuracy);
      } else {
        const circle = L.circle(latLng, {
          radius: accuracy,
          color: '#1976d2',
          fillColor: '#1976d2',
          fillOpacity: 0.15,
          weight: 1,
          opacity: 0.6,
        });
        circle.addTo(map);
        userAccuracyCircleRef.current = circle;
      }
    }
    drawNavigationLine();
  }, [drawNavigationLine, intl]);

  const refreshMarkerPopups = useCallback(() => {
    const userLoc = userLocationRef.current;
    Object.entries(equipmentMarkersRef.current).forEach(([registerNumber, marker]) => {
      if (!marker) return;
      const trackpoint = latestTrackpointsRef.current[registerNumber];
      if (!trackpoint) return;

      if (userLoc) {
        const distance = calculateDistanceKm(userLoc, marker.getLatLng());
        trackpoint.distanceToUserKm = distance;
        trackpoint.travelTimeMinutes = Number.isFinite(distance) && AVERAGE_TRAVEL_SPEED_KMH > 0
          ? (distance / AVERAGE_TRAVEL_SPEED_KMH) * 60
          : null;
      } else {
        delete trackpoint.distanceToUserKm;
        delete trackpoint.travelTimeMinutes;
      }

      marker.setPopupContent(showContent(trackpoint, authUser, intl, routePopupOptions));
    });

    drawNavigationLine();
  }, [authUser, drawNavigationLine, intl, routePopupOptions]);

  useEffect(() => {
    refreshMarkerPopups();
  }, [refreshMarkerPopups]);

  const initMap = () => {


    //const selectedLayer = 'hybridMap';

    mapInstance = L.map("map", {
      center: [-33.447487, -70.673676],
      zoom: 10,
      maxZoom: 20,
      scrollWheelZoom: true,
      //layers: [layers[intl.formatMessage({ id: `routingmap.${selectedLayer}` })]],
    });



    mapInstance.zoomControl.setPosition("bottomright");
    mapRef.current = mapInstance;

  };

  // AuthUser via postMessage
  useEffect(() => {
    const handleMessage = ({ origin, data }) => {
      if (
        (origin === process.env.REACT_APP_LOCALHOST_URL ||
          origin === process.env.REACT_APP_FRONT_BASE_URL) &&
        data?.type === "SHARE_DATA"
      ) {
        setAuthUser(data.payload.authUser);
        localStorage.setItem("authUser", JSON.stringify(data.payload.authUser));
      }
    };
    window.addEventListener("message", handleMessage);
    const stored = localStorage.getItem("authUser");
    if (stored) setAuthUser(JSON.parse(stored));
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  useEffect(() => {
    if (typeof navigator === 'undefined' || !navigator.geolocation) {
      setGeoError(intl.formatMessage({ id: 'gps.geolocationUnsupported', defaultMessage: 'Geolocation is not supported by this browser.' }));
      return;
    }

    const handleSuccess = (position) => {
      const { latitude, longitude, accuracy } = position.coords;
      const coords = { lat: latitude, lng: longitude, accuracy };
      userLocationRef.current = coords;
      setUserLocation(coords);
      setGeoError(null);
      updateUserMarker(coords);
      refreshMarkerPopups();
      drawNavigationLine();
    };

    const handleError = (error) => {
      console.warn('Geolocation error:', error);
      const fallbackMessage = intl.formatMessage({ id: 'gps.geolocationError', defaultMessage: 'Unable to retrieve your location.' });
      const details = error?.message ? `${fallbackMessage} (${error.message})` : fallbackMessage;
      setGeoError(details);
      userLocationRef.current = null;
      setUserLocation(null);
      refreshMarkerPopups();
      drawNavigationLine();
    };

    try {
      const watchId = navigator.geolocation.watchPosition(handleSuccess, handleError, {
        enableHighAccuracy: true,
        maximumAge: 30000,
        timeout: 20000,
      });
      geoWatchIdRef.current = watchId;
    } catch (error) {
      handleError(error);
    }

    return () => {
      if (geoWatchIdRef.current != null && typeof navigator !== 'undefined' && navigator.geolocation && typeof navigator.geolocation.clearWatch === 'function') {
        navigator.geolocation.clearWatch(geoWatchIdRef.current);
        geoWatchIdRef.current = null;
      }
      if (userMarkerRef.current) {
        userMarkerRef.current.remove();
        userMarkerRef.current = null;
      }
      if (userAccuracyCircleRef.current) {
        userAccuracyCircleRef.current.remove();
        userAccuracyCircleRef.current = null;
      }
      if (userRouteControlRef.current) {
        userRouteControlRef.current.remove();
        userRouteControlRef.current = null;
      }
      selectedVehicleRef.current = null;
    };
  }, [drawNavigationLine, intl, refreshMarkerPopups, updateUserMarker]);


  const query = useMemo(() => {
    if (!authUser || equipmentId == null) return null;
    let groupId = getGroupFilterQuery("equipmentId", undefined, authUser);
    let parentGroupId = null;
    if (group && group.value != -1) {
      groupId = group.value;
    } else if (parentGroup && parentGroup.value != -1) {
      parentGroupId = parentGroup.value;
    }
    setLoading(true);
    if (equipmentMarkersRef.current) {
      setEquipments([]);
      Object.entries(equipmentMarkersRef.current).forEach(([registerNumber, marker]) => {
        markerLayerRef.current.removeLayer(marker); // remove from map
        delete equipmentMarkersRef.current[registerNumber]; // remove reference
        delete latestTrackpointsRef.current[registerNumber];
        if (selectedVehicleRef.current === registerNumber) {
          selectedVehicleRef.current = null;
        }
      });
      latestTrackpointsRef.current = {};
      drawNavigationLine(null);
      firstFitRef.current = true;
    }

    return {
      companyId: getCompanyId(authUser),
      imei: null,
      token: authUser?.token??null,
      equipmentId: equipmentId,
      event: "monitorgps",
      groupId: groupId ? groupId : getGroupFilterQuery("equipmentId", undefined, authUser),
      parentGroupId: parentGroupId,
    };
  }, [authUser, equipmentId]);



  // Smooth animation helper
  const animateMarker = useCallback((marker, toLatLng, speed = 0) => {
    if (!marker) return;

    const [toLat, toLng] = Array.isArray(toLatLng) ? toLatLng : [];
    const toValid = Number.isFinite(toLat) && Number.isFinite(toLng);

    // Skip animation when the target coordinates are not valid
    if (!toValid) {
      return;
    }

    if (!pageVisible) {
      marker.setLatLng([toLat, toLng]);
      return;
    }

    const from = marker.getLatLng();
    if (!from || !Number.isFinite(from.lat) || !Number.isFinite(from.lng)) {
      marker.setLatLng([toLat, toLng]);
      return;
    }

    const distance = L.latLng(from).distanceTo([toLat, toLng]);
    const duration = speed > 0 && Number.isFinite(speed)
      ? distance / (speed / 3.6)
      : 1800;
    const start = performance.now();
    const easeOut = t => t * (2 - t);

    function step(now) {
      const progress = Math.min((now - start) / duration, 1);
      const eased = easeOut(progress);
      const lat = from.lat + (toLat - from.lat) * eased;
      const lng = from.lng + (toLng - from.lng) * eased;
      const newLat = Number.isFinite(lat) ? lat : toLat;
      const newLng = Number.isFinite(lng) ? lng : toLng;
      marker.setLatLng([newLat, newLng]);
      if (progress < 1) requestAnimationFrame(step);
    }

    requestAnimationFrame(step);
  }, [pageVisible]);

  // Create or update markers
  const updateOrCreateMarkers = useCallback(
    (data) => {
      const layer = markerLayerRef.current;
      if (!layer) return;
      if (Array.isArray(data)) {
        data
          .filter(
            (key) =>
              Number.isFinite(parseFloat(key.latitude)) &&
              Number.isFinite(parseFloat(key.longitude))
          )
          .forEach((eq) => {
            const {
              registerNumber,
              latitude = 0,
              longitude = 0,
              course = 0,
            } = eq;
            const latNum = parseFloat(latitude);
            const lngNum = parseFloat(longitude);
            if (!Number.isFinite(latNum) || !Number.isFinite(lngNum)) {
              return;
            }
            eq.speed = convertToFormat(eq.speed, 'kmh');
            const overSpeed = authUser?.company?.overSpeed ?? Infinity;
            const iconSvg = getMapIcon(eq.type, course, eq.speed, eq.fixtime, overSpeed);
            const icon = L.divIcon({
              html: `
                <div style="display:flex;align-items:center;justify-content:center;">
                  ${iconSvg}
                </div>
              `,
              className: "",
              iconSize: [18, 18],
              iconAnchor: [9, 9],
              popupAnchor: [0, -10]
            });

            let marker = equipmentMarkersRef.current[registerNumber];
            latestPositionsRef.current[registerNumber] = { lat: latNum, lng: lngNum };
            const userCoords = userLocationRef.current;
            const distanceToUserKm = userCoords ? calculateDistanceKm(userCoords, { lat: latNum, lng: lngNum }) : null;
            const travelTimeMinutes = Number.isFinite(distanceToUserKm) && AVERAGE_TRAVEL_SPEED_KMH > 0
              ? (distanceToUserKm / AVERAGE_TRAVEL_SPEED_KMH) * 60
              : null;
            const trackpoint = { ...eq, distanceToUserKm, travelTimeMinutes };
            latestTrackpointsRef.current[registerNumber] = trackpoint;

            if (selectedVehicleRef.current === registerNumber) {
              drawNavigationLine({ lat: latNum, lng: lngNum });
            }

            const attachClick = (m) => {
              m.off('click');
              m.on('click', () => {
                // Clear any selected vehicle in the filter when user clicks a marker
                setEquipment(null);
                setSearchTerm("");
                focusedMarkers.clear();

                const map = mapRef.current;
                const latLng = m.getLatLng();
                if (map) map.setView(latLng, 17);
                selectedVehicleRef.current = registerNumber;
                drawNavigationLine(latLng);
                m.openPopup();
              });
            };

            if (marker) {
              // smooth-move
              animateMarker(marker, [latNum, lngNum], parseFloat(eq.speed));
              marker.setIcon(icon);
              marker.setPopupContent(showContent(trackpoint, authUser, intl, routePopupOptions)); // Ensures latest popup content
              const popupInstance = marker.getPopup();
              if (popupInstance) {
                popupInstance.options.autoPan = false;
                popupInstance.options.autoClose = false;
                popupInstance.options.closeOnClick = false;
                popupInstance.options.closeButton = false;
              }
              if (!marker.isPopupOpen()) {
                marker.openPopup();
              }
              attachClick(marker);
            } else {
              // create new
              marker = L.marker([latNum, lngNum], { icon })
              marker.bindPopup(showContent(trackpoint, authUser, intl, routePopupOptions), {
                autoPan: false,
                autoClose: false,
                closeOnClick: false,
                closeButton: false,
              });
              attachClick(marker);

              marker.on("popupopen", () => {
                const latLng = marker.getLatLng();
                const map = mapRef.current;
                if (map) {
                  const point = map.latLngToContainerPoint(latLng);
                  point.y -= 80;
                  const newLatLng = map.containerPointToLatLng(point);
                  map.panTo(newLatLng, { animate: true });
                }

                const button = document.getElementById(`popupButton-${registerNumber}`);
                if (button) {
                  button.addEventListener("click", () => {
                    setStreetLocation({
                      latitude: marker.getLatLng().lat,
                      longitude: marker.getLatLng().lng,
                    });
                    setStreetViewModal(true);
                  });
                }

                const googleButton = document.getElementById(`googleButton-${registerNumber}`);
                if (googleButton) {
                  googleButton.addEventListener("click", (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    const { lat, lng } = marker.getLatLng();
                    const url = `https://www.google.com/maps?q=${lat},${lng}`;
                    window.open(url, "_blank", "noopener");
                  });
                }

                const wazeButton = document.getElementById(`wazeButton-${registerNumber}`);
                if (wazeButton) {
                  wazeButton.addEventListener("click", (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    const { lat, lng } = marker.getLatLng();
                    const url = `https://www.waze.com/ul?ll=${lat},${lng}&navigate=yes`;
                    window.open(url, "_blank", "noopener");
                  });
                }

                const streetViewButton = document.getElementById(`streetViewButton-${registerNumber}`);
                if (streetViewButton) {
                  streetViewButton.addEventListener("click", (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    const { lat, lng } = marker.getLatLng();
                    const url = `https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${lat},${lng}`;
                    window.open(url, "_blank", "noopener");
                  });
                }
              });

              // Optional: clean up
              marker.on("popupclose", () => {
                const button = document.getElementById(`popupButton-${registerNumber}`);
                if (button) {
                  button.removeEventListener("click", () => { });
                }

                const googleButton = document.getElementById(`googleButton-${registerNumber}`);
                if (googleButton) {
                  googleButton.removeEventListener("click", () => { });
                }

                const wazeButton = document.getElementById(`wazeButton-${registerNumber}`);
                if (wazeButton) {
                  wazeButton.removeEventListener("click", () => { });
                }

                const streetViewButton = document.getElementById(`streetViewButton-${registerNumber}`);
                if (streetViewButton) {
                  streetViewButton.removeEventListener("click", () => { });
                }
              });
              equipmentMarkersRef.current[registerNumber] = marker;
              layer.addLayer(marker);
              marker.openPopup();
            }
          });
      }

    },
    [animateMarker, authUser, drawNavigationLine, intl, routePopupOptions]
  );

  // When page becomes visible again, jump markers to their last known positions
  useEffect(() => {
    if (!pageVisible) return;
    Object.entries(equipmentMarkersRef.current).forEach(([id, marker]) => {
      const pos = latestPositionsRef.current[id];
      if (pos) {
        marker.setLatLng([pos.lat, pos.lng]);
      }
    });
  }, [pageVisible]);

  const drawGeoZones = () => {
    if (!geoZones?.length || polyLineLayer.length > 0) return;

    geoZones.forEach((zone) => {
      const shape = parse(zone.area);
      const coords = shape?.coordinates;
      const options = { color: zone.activeColor || 'blue', weight: 4 };
      const poly = shape.type === "LineString" ? new L.polyline(coords, options) : new L.polygon(coords, options);

      poly.bindPopup(`<strong>${zone.name}</strong>`).addTo(mapInstance);
      poly.on('popupopen', (e) => {
        // const mid = Math.floor(e.popup._source._latlngs.length / 2);
        // e.popup.setLatLng(e.popup._source._latlngs[mid]);
      });
    });

    polyLineLayer.push(...geoZones);
  };


  const streetViewCancel = () => {
    setStreetViewModal(false);
  };


  // One-time fit to all markers
  useEffect(() => {
    if (!equipments.length || !mapRef.current || !firstFitRef.current) return;
    const bounds = L.latLngBounds();
    equipments.forEach((eq) => {
      if (eq.latitude && eq.longitude) {
        bounds.extend([eq.latitude, eq.longitude]);
      }
    });
    if (bounds.isValid()) {
      mapRef.current.fitBounds(bounds, { padding: [50, 50] });
    }
    firstFitRef.current = false;
  }, [equipments, searchTerm]);

  // WebSocket hookup
  useEffect(() => {
    if (!query) return;
    console.log("query=======",query)
    const socket = socketIOClient(webSocket, {
      path: "/websocket",
      transports: ["websocket"],
      query: { data: JSON.stringify(query) },
    });
    socketRef.current = socket;

    socket.on("totalEquipments", (data) => {
      setLoading(false);
      let updatedArray = data.map(item => ({
        ...item,
        label: item[authUser && authUser.company.format ? authUser.company.format : "registerNumber"],
        value: item.id // new field
      }));
      if (0 < updatedArray.length) {
        updatedArray = [{ value: -1, label: "Todos" }, ...updatedArray]
      }
      setEquipmentsOptions(updatedArray);
      setEquipments(data);
      updateOrCreateMarkers(data);
    });

    socket.on("monitor_gps_error", (error) => {
      console.log('error==monitor_gps_error==',error)
      setLoading(false);
      setEquipments([]);
      //alert(error.error);
    });

    socket.on("monitor_gps_response", (updatedData) => {
      console.log('updatedData====',updatedData)
      if (updatedData) {
        setEquipments(prevEquipments => {
          // Create a map of updated equipment by ID (or unique key)
          const updatedMap = new Map(updatedData.map(e => [e.id, e]));

          // Merge: if ID exists, replace; else keep existing
          const merged = prevEquipments.map(e =>
            updatedMap.has(e.id) ? updatedMap.get(e.id) : e
          );
          return merged;
        });
      } else {
        setLoading(false);
      }
      updateOrCreateMarkers(updatedData);
    });
    const iid = setInterval(
      () => socket.emit("monitor_gps_request", { data: JSON.stringify(query) }),
      2000
    );
    return () => {
      clearInterval(iid);
      socket.disconnect();
    };
  }, [query, updateOrCreateMarkers]);

  // Debounced search
  const debouncedFilter = useMemo(
    () =>
      debounce((term) => {
        if (!mapRef.current || !term) return;
        const match = equipments.find(
          (eq) =>
            eq.registerNumber?.toLowerCase().includes(term.toLowerCase()) ||
            eq.name?.toLowerCase().includes(term.toLowerCase())
        );
        if (match) {
          if (!focusedMarkers.has(match.id)) {
            focusedMarkers.add(match.id);
            const m = equipmentMarkersRef.current[match.registerNumber];
            if (m) mapRef.current.setView(m.getLatLng(), 17);
          }
          // If already focused, do not keep re-centering on updates.
        }
      }, 300),
    [equipments]
  );

  useEffect(() => {
    debouncedFilter(searchTerm);
  }, [searchTerm, debouncedFilter]);

  useEffect(() => {
    if (equipment) {
      if (equipment.value == -1) {
        firstFitRef.current = true;
      }
      focusedMarkers.clear();
      setSearchTerm(equipment.value == -1 ? '' : equipment.registerNumber)
    }
  }, [equipment]);

  const handleSearchChange = useCallback((e) => {
    setSearchTerm(e.target.value);
  }, []);

  const handleSubmit = async () => {
    if (!routeCode) {
      //{intl.formatMessage({ id: "route_required" })}
      toast.error(intl.formatMessage({ id: "route_required" }));
    } else {
      try {
        setLoading(true)
        let apiPath = `searchroutes?page=0&limit=100&filter_code=${routeCode}&sort_updatedAt=desc`;
        let response = await api.getAppApi(apiPath);
        console.log('response=====', response);
        if (response.status == 'success') {
          const routeData = response.data;
          if (routeData.rows && routeData.rows.length > 0) {
            const row = routeData.rows[0];
            let equipmentId1 = row.equipment.map(key => key.id).toString();
            setAuthUser({...row});
            setEquipmentId(equipmentId1.length==0?null:equipmentId1);
            if(equipmentId1.length==0){
              toast.error(intl.formatMessage({ id: "no_data" }));
            }
            const areas = row.areaPolyLine;
            if (areas && Array.isArray(areas) && 0 < areas.length) {
              const coords = areas[0].coordinates;
              const options = { color: 'blue', weight: 4 };
              const poly = areas[0].type === "LineString" ? new L.polyline(coords, options) : new L.polygon(coords, options);
              poly.addTo(mapInstance);
            }

          }
          else {
            toast.error(intl.formatMessage({ id: "no_data" }));
          }
        } else {
          toast.error(response.message);
        }
        setLoading(false)
      } catch (error) {
        console.error('Error fetching routes:', error);
        //showMsg(error.toString());
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <div className="viewdiv">
      {/* Search box */}
      <div className="filters">


        <div className="dropDowns" style={{ padding: 10, background: 'white', borderRadius: 8 }}>
          <label style={{ fontSize: 14, marginBottom: 4, display: 'block' }}>
            {intl.formatMessage({ id: "routecode" })}
          </label>
          <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            {/* <TextField
                  size="small"
                  variant="outlined"
                  value={routeCode}
                  onChange={(e) => setRouteCode(e.target.value)}
                  placeholder={intl.formatMessage({ id: "enter_route_code" })}
                  sx={{ minWidth: "73%" }}
                /> */}
            <TextField
              size="small"
              variant="outlined"
              value={routeCode}
              onChange={(e) => setRouteCode(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  handleSubmit();
                }
              }}
              placeholder={intl.formatMessage({ id: "enter_route_code" })}
              sx={{ minWidth: "73%" }}
            />
            <Button
              size="small"
              variant="contained"
              onClick={handleSubmit}
              sx={{ height: 36 }} style={{ textTransform: "capitalize" }}
            >
              {intl.formatMessage({ id: "submit" })}
            </Button>
          </div>
        </div>



      </div>
      {geoError && (
        <div
          style={{
            margin: '10px 0',
            padding: '8px 12px',
            background: '#fff',
            borderRadius: 8,
            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
            fontSize: 12,
          }}
        >
          {geoError}
        </div>
      )}
      <div id="map" />
      {/* Loading overlay */}
      {loading && (
        <div className="spinnerdiv" >
          <img
            src={loadingspinner}
            alt="loading"
            style={{ width: 30, height: 30 }}
          />
        </div>
      )}


      {IsStreetViewModal && (
        <StreetViewModalCard open={IsStreetViewModal} location={streetLocation} onCancel={streetViewCancel} />
      )}

      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
}
